export default __webpack_public_path__ + "static/media/x.c24866c1.svg";